export const USER_REQUEST = 'USER_REQUEST';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE_MAIL = 'USER_UPDATE_MAIL';
export const USER_AUTHORIZE = 'USER_AUTHORIZE';
export const USER_UPDATE_NOTIFY_SETTINGS = 'USER_UPDATE_NOTIFY_SETTINGS';